import { Link as GatsbyLink, GatsbyLinkProps } from "gatsby";
import { useLocale } from "../hooks/useLocale";

export const Link = ({ ...props }: GatsbyLinkProps<any>) => {
  const locale = useLocale();
  const to = locale === "fi" ? props.to : `/${locale}` + props.to;

  return (
    <GatsbyLink {...(props as any)} to={to}>
      {props.children}
    </GatsbyLink>
  );
};
